import kokImgOne from "../../../img/portfolio/kok/kok-1-optimized.jpg";
import kokImgTwo from "../../../img/portfolio/kok/kok-optimized.jpg";
import kokImgThree from "../../../img/portfolio/kok/kok-3-optimized.jpg";
import kokImgFour from "../../../img/portfolio/kok/kok-4-optimized.jpg";
import kokImgFive from "../../../img/portfolio/kok/kok-5-optimized.jpg";
import kokImgSix from "../../../img/portfolio/kok/kok-6-optimized.jpg";
import kokImgSeven from "../../../img/portfolio/kok/kok-7-optimized.jpg";
import kokImgEight from "../../../img/portfolio/kok/kok-8-optimized.jpg";

const kokImagesArray = [
    kokImgOne, 
    kokImgTwo,
    kokImgThree,
    kokImgFour,
    kokImgFive,
    kokImgSix,
    kokImgSeven,
    kokImgEight
]

export default kokImagesArray ;
